import type { ElementProps } from "../../functionalComponents/RenderPage";
import type { ReactElement } from "react";
import styled from "styled-components";

const StyledStickyHeader = styled.header``;

const StickyHeader = (): ReactElement<ElementProps> => (
	<StyledStickyHeader className="sticky-menu" />
);

export default StickyHeader;
